import React from 'react';
import { Callout } from 'components/layout/Callout';
import { Placement } from 'popper.js';
import { IActionLinkItems } from 'components/ActionLinks/ActionLinkModels';
import { ActionHeader, BaseActionType } from '@decisions/server/DecisionsFramework/ServiceLayer/Actions';
import { ActionLinks } from 'components/ActionLinks/ActionLinks';
import { ActionsFavoriteButton } from './ActionsFavoriteButton';
import { executeFavoriteActionOnAction } from 'utils/ActionUtils';
// import './ActionLinksCallout.less'

interface IActionLinksCalloutProps {
  sourceRef: React.MutableRefObject<HTMLElement | null>;
  placement?: Placement;
  nestedPlacement?: Placement;
  loading?: boolean;
  onClose: () => void;
  links?: IActionLinkItems;
  extraLinks?: IActionLinkItems[];
  /**
   * Actions map required to be able to favorite actions
   */
  actionsById?: Map<string, BaseActionType | ActionHeader>;
}

const loadingLinks: IActionLinkItems = {
  current: [
    {
      label: 'Loading...',
      value: '',
      disabled: true,
    },
  ],
};

/**
 * A "controlled" Action links callout, meaning it's stateless and doesn't load its own
 * action links, useful when you have already processed actions -> action links for
 * another reason. Used inside ActionLinksCallout.
 *
 * Copyright (c) 2021 Decisions All Rights Reserved
 */
export function ActionLinksCallout({
  links,
  loading,
  actionsById,
  extraLinks,
  nestedPlacement,
  ...calloutProps
}: IActionLinksCalloutProps) {
  const onFavoriteClick = (actionId: string, e: React.MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    // trigger the favorite-ness
    const act = actionsById?.get(actionId);
    if (!act) {
      return;
    }
    executeFavoriteActionOnAction(act, e.currentTarget);
    // probably close this, too
    calloutProps.onClose();
  };

  return (
    <Callout
      isOpen={!!links || !!loading}
      className="dp-actions-callout"
      flipBehavior="flip"
      showArrow={true}
      // I think overlayClickPropagation setting here was to catch context menu outside portal context,
      // but it maybe isn't needed, and causes other problems as a default
      // overlayClickPropagation={'right'}
      {...calloutProps}
    >
      <ActionLinks
        values={links || loadingLinks}
        extraValues={extraLinks}
        placement={nestedPlacement || calloutProps.placement}
        dividerForGroups={false}
        // resorting to inline handler here to get the value from render props:
        afterLabels={link => (
          <ActionsFavoriteButton
            isFavorite={link.isFavorite}
            disabled={!link.canEditFavorite}
            label={link.label}
            onClick={e => onFavoriteClick(link.value, e)}
          />
        )}
      />
    </Callout>
  );
}
